import React from 'react';
import { Box } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { fetchBookingShows } from '../../api/bookingAssistance';
import PersonAddAlt1Outlined from '@mui/icons-material/PersonAddAlt1Outlined';

export default function BookingAssistanceLink({ compact = false }: { compact?: boolean }) {
  const { pathname } = useLocation();
  const [visible, setVisible] = React.useState(false);
  React.useEffect(() => {
    let active = true;
    void fetchBookingShows().then(value => { if (active) setVisible(Array.isArray(value.shows) && value.shows.length > 0); }).catch(() => { if (active) setVisible(false); });
    return () => { active = false; };
  }, [pathname]);
  if (!visible) return null;
  return <Box sx={{ '& a': { display:'flex',flexDirection:compact?'column':'row',alignItems:'center',justifyContent:compact?'center':'flex-start',gap:1,color:pathname==='/booking-assistance'?'#D175B6':'#fff',p:compact?1.5:2,fontSize:compact?14:18,lineHeight:1.4,textAlign:compact?'center':'left',border:pathname==='/booking-assistance'?'1px solid #D175B6':'1px solid transparent',borderRadius:2 } }}><Link to="/booking-assistance"><PersonAddAlt1Outlined sx={{fontSize:compact?34:22,flexShrink:0}}/><span>Booking assistance</span></Link></Box>;
}
